import React, { ComponentProps, FC } from "react";
import { IFlow } from "../services/createFlow";

export const withFlow = <T extends Record<string, unknown>, S extends object>(
  flow: IFlow<T, S>,
  Component: FC
) => {
  const Provider = (
    props: Omit<ComponentProps<IFlow<T, S>["Provider"]>, "children">
  ) => {
    return (
      <flow.Provider {...props}>
        <Component />
      </flow.Provider>
    );
  };

  Provider.root = flow.root;

  return Provider;
};
